module.exports = __webpack_public_path__ + "static/media/icon_video_quality_settings.41e6a464.svg";